import addCookieWithConsent from '../pattern_utilities/addCookieWithConsent';

export * from './team/a.t.POST.create-firm.js';
export * from './team/a.t.POST.create-enterprise.js';
export * from './team/a.t.GET.js';

export * from './team/a.t.PUT.change-name.js';
export * from './team/a.t.PUT.change-signature.js';
export * from './team/a.t.PUT.change-theme.js';

// export * from './team/a.t.PUT.change-billing-info.js';
export * from './team/a.t.PUT.accept-invite.js';
// export * from './team/a.t.PUT.join-enterprise.js';
export * from './team/a.t.PUT.leave.js';
// export * from './team/a.t.PUT.migrate.js';
// export * from './team/a.t.PUT.change-seats.js';
// export * from './team/a.t.PUT.preview-seat-change.js';

export * from './team/a.t.POST.create-portal-session.js';
export * from './team/a.t.POST.create-checkout-session.js';
export * from './team/a.t.POST.create-reactivate-checkout-session.js';

// export * from './team/a.t.GET.invoice.js';
// export * from './team/a.t.GET.past-invoices.js';
// export * from './team/a.t.GET.billing-status.js';
// export * from './team/a.t.GET.payment-methods.js';
// export * from './team/a.t.DELETE.payment-method.js';
// export * from './team/a.t.POST.payment-method.js';
// export * from './team/a.t.POST.set-default-payment-method.js';

export * from './team/a.t.DELETE.firm.js';
// export * from './team/a.t.DELETE.enterprise.js';


export const setCurrentTeam = data => dispatch => {
  addCookieWithConsent(process.env.REACT_APP_CURRENT_TEAM, window.btoa(data), dispatch);

  dispatch(thenSetCurrentTeam(data));
}

export const thenSetCurrentTeam = data => ({
  type: 'SET_CURRENT_TEAM',
  data
})

export const unsetCurrentTeam = data => ({
  type: 'UNSET_CURRENT_TEAM',
  data
})

export const updateTeamStaffing = data => ({
  type: 'UPDATE_TEAM_STAFFING',
  data
})



export const hideTeamToFirmMigrateSettingsPrompt = data => dispatch => {

  addCookieWithConsent(process.env.REACT_APP_CURRENT_TEAM + "_" + data.id + "_migrate", "hidden", dispatch, 1)

  return {
    type: 'HIDE_TEAM_TO_FIRM_MIGRATE_PROMPT',
    data
  }
}



// WEBPACK FOOTER //
// ./src/actions/actions.team.js